import { render, staticRenderFns } from "./Incubator.vue?vue&type=template&id=c6869184"
import script from "./Incubator.vue?vue&type=script&lang=js"
export * from "./Incubator.vue?vue&type=script&lang=js"
import style0 from "./Incubator.vue?vue&type=style&index=0&id=c6869184&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports